<template>
  <div
    class="main-content-container"
    v-loading="quitLoading"
    :class="[`${$i18n.locale}`, showHeader ? 'normal' : 'no-header']"
  >
    <div
      class="header-top flex align-center"
      :class="customHead ? 'custom-header' : ''"
      v-if="showHeader"
    >
      <Logo />
      <!-- 左侧按钮 start -->
      <div class="left-btns-box flex-1 flex" :class="showUpgradeOfficial ? 'media-left' : ''">
        <!-- 名片夹 -->
        <span
          class="ht-btn"
          @click="toGO('/card/view', 'click_cardholder_tab')"
          :class="{ 'active-btn': checkActiveMenu(menuList.CARD) }"
          v-if="CP('show_company_cardholder')"
        >
          {{ $t('client') }}
        </span>
        <!-- 公司 -->
        <span
          class="ht-btn"
          @click="toGO('/company/index', 'click_enterprise_tab')"
          :class="{ 'active-btn': checkActiveMenu(menuList.COMPANY) }"
          v-if="isCorp && CP('show_company_cardholder')"
        >
          {{ $t('company_tab') }}
        </span>
        <!-- 报表 -->
        <span
          class="ht-btn"
          @click="toGO('/report/cardtotal', 'click_report_tab')"
          :class="{ 'active-btn': checkActiveMenu(menuList.REPORT) }"
          v-if="isCorp && CP('corp_package_expircy')"
        >
          {{ $t('report') }}
        </span>
        <!-- 营销邮件 -->
        <span
          class="ht-btn"
          @click="toGO('/edm/list', 'click_marketing_email_tab')"
          :class="{
            'active-btn': checkActiveMenu(menuList.EDM),
            'edm-point': !checkActiveMenu(menuList.EDM) && edmMsg.show_edm_point
          }"
          v-if="CP('show_edm')"
        >
          {{ $t('edm_com_title') }}
        </span>
        <!-- 商谈记录 -->
        <span
          class="ht-btn"
          @click="toGO('/note/view', 'click_negotiation_record_tab')"
          :class="{ 'active-btn': checkActiveMenu(menuList.NOTE) }"
          v-if="CP('enable_tasks') && CP('enable_tasks_corp')"
        >
          {{ $t('remark') }}
        </span>
        <!-- 任务 -->
        <span
          class="ht-btn"
          id="taks-menu-btn"
          @click="toGO('/task/view', 'click_assignment_tab')"
          :class="{ 'active-btn': checkActiveMenu(menuList.TASK) }"
          v-if="CP('enable_tasks') && CP('enable_tasks_corp')"
        >
          {{ $t('icon_task_tiptext') }}
        </span>
        <!-- 同事 -->
        <span
          class="ht-btn"
          id="colleague-menu-btn"
          @click="toGO('/colleague/view', 'click_workmate_tab')"
          :class="{ 'active-btn': checkActiveMenu(menuList.COLLEAGUE) }"
          v-if="isCorp && CP('view_colleague_list') && CP('view_colleague_info')"
        >
          {{ $t('colleague') }}
        </span>
        <!-- 适配，隐藏部分菜单 -->
        <div class="wrap-drop-down">
          <div
            class="ht-btn more"
            :class="{
              'active-btn': checkActiveMenu(menuList.TASK) || checkActiveMenu(menuList.COLLEAGUE)
            }"
            v-if="
              (CP('enable_tasks') && CP('enable_tasks_corp')) ||
              (isCorp && CP('view_colleague_list') && CP('view_colleague_info'))
            "
          >
            <i class="icomoon-more"></i>
            <div class="select-menu-list">
              <!-- 任务 -->
              <div
                class="list-item"
                @click="toGO('/task/view', 'click_assignment_tab')"
                :class="{ 'active-btn font-bold': checkActiveMenu(menuList.TASK) }"
                v-if="CP('enable_tasks') && CP('enable_tasks_corp')"
              >
                {{ $t('icon_task_tiptext') }}
              </div>
              <!-- 同事 -->
              <div
                class="list-item"
                @click="toGO('/colleague/view', 'click_workmate_tab')"
                :class="{ 'active-btn font-bold': checkActiveMenu(menuList.COLLEAGUE) }"
                v-if="isCorp && CP('view_colleague_list') && CP('view_colleague_info')"
              >
                {{ $t('colleague') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end -->
      <!-- 右侧按钮 -->
      <div class="right-btns-box flex align-center">
        <ChangeLang v-if="DEV"></ChangeLang>
        <!-- 升级到正式版 -->
        <span
          v-if="showUpgradeOfficial"
          id="upgrade-official-btn"
          @click="toGO('/payment/price', '')"
          target="_blank"
        >
          <i class="icomoon-upload1"></i>
          {{ $t('update_to_official') }}
        </span>
        <!-- 管理 -->
        <span
          class="ht-btn"
          @click="toGO('/admin/accountinfo', '')"
          :class="{ 'active-btn': checkActiveMenu(menuList.MANAGE) }"
          v-if="CP('show_manage')"
        >
          <span class="tips">{{ $t('management') }}</span>
          <i class="icomoon-tool"></i>
        </span>
        <!-- 工具箱 -->
        <span
          class="ht-btn"
          @click="toGO('/tool/excel', '')"
          :class="{ 'active-btn': checkActiveMenu(menuList.TOOL) }"
        >
          <span class="tips">{{ $t('tool_box') }}</span>
          <i class="icomoon-admin"></i>
        </span>
        <!-- 消息 -->
        <div
          class="wrap-drop-down to-click"
          @click="handleShowMsg"
          @mouseleave="delayHide('showMsgMenu')"
        >
          <div
            v-if="!adminExpire"
            class="ht-btn ht-btn-outer-container"
            :class="{ 'active-btn': checkActiveMenu(menuList.MESSAGE) }"
          >
            <span class="tips" v-if="!showMsgMenu">{{ $t('icon_message_tiptext') }}</span>
            <i class="icomoon-im"></i>
            <ul v-if="showMsgMenu" class="msg-pannel-box select-menu-list">
              <!-- 名片共享 -->
              <li
                class="list-item"
                @click="toGO('/message/center', 'click_card_share')"
                :class="{ active: msgNum.share_num }"
                v-if="user.role !== 2"
              >
                <div class="flex-1 flex align-center">
                  <i class="icomoon-card"></i>
                  <span class="msg-text">{{ $t('camcard_share') }}</span>
                </div>
                <div class="msg-num">{{ msgNum.share_num }}</div>
              </li>
              <!-- 任务协作 -->
              <li
                class="list-item"
                :class="{ active: msgNum.task_num }"
                @click="toGO('/message/taskcenter', 'click_task_cooperate')"
                v-if="user.role === 0 || user.role === 1"
              >
                <div class="flex-1 flex align-center">
                  <i class="icomoon-task"></i>
                  <span class="msg-text">{{ $t('task_share') }} </span>
                </div>
                <div class="msg-num">{{ msgNum.task_num }}</div>
              </li>
              <!-- 待加入的同事 -->
              <li
                class="list-item"
                v-if="CP('show_manage')"
                :class="{ active: msgNum.apply_num }"
                @click="toGO('/message/applylist', 'click_tobe_join_colleagues')"
              >
                <div class="flex-1 flex align-center">
                  <i class="icomoon-title"></i>
                  <span class="msg-text">{{ $t('apply_list') }} </span>
                </div>
                <div class="msg-num">{{ msgNum.apply_num }}</div>
              </li>
              <!-- 人事变更（只有日本地区才有） -->
              <li
                class="list-item"
                v-if="CP('show_hrchange') && !CP('is_read_only') && !CP('is_normal_admin')"
                :class="{ active: msgNum.hrchange_num }"
                @click="toGO('/message/hrchange', 'click_hr_change')"
              >
                <div class="flex-1 flex align-center">
                  <i class="icomoon-hr"></i>
                  <span class="msg-text">{{ $t('hrchange_show') }} </span>
                </div>
                <div class="msg-num">{{ msgNum.hrchange_num }}</div>
              </li>
              <!-- 名片上传 -->
              <li
                class="list-item"
                v-if="user.role !== 2"
                :class="{ active: msgNum.upload_card_num }"
                @click="toGO('/message/uploadcard', 'click_card_upload_log')"
              >
                <div class="flex-1 flex align-center">
                  <i class="icomoon-upload"></i>
                  <span class="msg-text">{{ $t('card_upload') }} </span>
                </div>
                <div class="msg-num">{{ msgNum.upload_card_num || 0 }}</div>
              </li>
            </ul>
            <div v-if="hasNewMsg" class="msg-alert-icon"></div>
          </div>
        </div>
        <!-- 帮助 -->
        <div class="help-btn-wrapper">
          <div class="help-divider"></div>
          <button class="help-btn" @click="goToHelpCenter">
            <i class="icomoon-help"></i>
            <span>{{ $t('help') }}</span>
          </button>
        </div>
        <!-- 头像 -->
        <div class="wrap-drop-down">
          <div class="avatar-box" @mouseleave="handleUserMenu(false)">
            <span class="flex align-center cursor-pointer">
              <user-avatar
                :username="user_info.user_name"
                :userId="user_info.user_id"
                :avatar="user_info.photo"
                class="avatar"
                @click="handleUserMenu(true)"
                @mouseover="ableTooltip = true"
                @mouseleave="delayHide('ableTooltip')"
              ></user-avatar>
              <i class="icomoon-sanjiao"></i>
            </span>
            <!-- </el-tooltip> -->
            <div class="user-menu-list head-menu select-menu-list">
              <div class="avatar-item list-item flex align-center cursor-default">
                <user-avatar
                  :username="user_info.user_name"
                  :userId="user_info.user_id"
                  :avatar="user_info.photo"
                  class="avatar"
                ></user-avatar>
                <span class="hide-long">{{ user_info.account || user_info.user_name }}</span>
              </div>
              <!-- 查看个人信息 -->
              <div
                class="list-item cursor-pointer"
                v-if="CP('user_profile') && CP('view_colleague_list')"
                @click="handleViewProfile"
              >
                <a class="link_ums">
                  <span class="icomoon-title"></span>
                  {{ $t('view_my_profile') }}
                </a>
              </div>
              <!-- 退出登录 -->
              <div @click="handleLogout" class="list-item cursor-pointer">
                <a class="link_ums">
                  <span class="icomoon-quit"></span>
                  {{ $t('logout') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inner-layout-content" :class="wap ? 'wap-page' : ''">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <!-- 问卷调查（中简、中繁）/个人信息补充（英文） -->
    <questionnaire ref="questionnaire" @submit="openNewcomerGuide" />

    <!-- 新手引导 -->
    <newcomer-guide ref="newcomerGuide" />
  </div>
</template>
<script>
  // import PERMISSION from '@/config/permission';
  import CONFIG from '@/config'
  import { getCookie } from '@/utils/tool'
  import { updateDpsPopupStatus, useLoginStatus } from '@/utils/useStore'
  import UserAvatar from '@/components/UserAvatar'
  import { getLatestMessage } from '@/services/message'
  import { mapGetters, mapState } from 'vuex'
  import Questionnaire from '@/components/Questionnaire'
  import NewcomerGuide from '@/components/NewcomerGuide'
  import Logo from '@/components/Logo'
  import ChangeLang from '@/components/changeLang'
  import { check_first_login } from '@/services/user'
  import { get_edm_pop, report_edm_click } from '@/services/edm'
  import ua from '@/utils/ua'

  export default {
    components: {
      'user-avatar': UserAvatar,
      questionnaire: Questionnaire,
      'newcomer-guide': NewcomerGuide,
      ChangeLang,
      Logo
    },
    data() {
      return {
        DEV: __DEV__ || +localStorage.debugger == 1, // 调试多语言使用
        CONFIG,
        // PERMISSION,
        PAYMENT: CONFIG.PAYMENT,
        user_info: {},
        quitLoading: false,
        showMsgMenu: false,
        ableTooltip: false,
        switchBoxVisible: false,
        menuList: {
          CARD: 'card', // 名片夹
          COMPANY: 'company', // 公司
          REPORT: 'report', // 报表
          EDM: 'edm', // 营销邮件
          NOTE: 'note', // 商谈记录
          TASK: 'task', // 任务
          COLLEAGUE: 'colleague', // 同事
          MANAGE: 'admin', // 管理
          TOOL: 'tool', // 工具箱
          MESSAGE: 'message' // 消息
        },
        helpUrl: '',
        userManual: '',
        adminManual: '',
        vipSupportEmail: '',
        downloadUrl: '',
        contactUs: '',
        hasNewMsg: false,
        adminExpire: false // 当前用户会员是否已过期
      }
    },
    computed: {
      ...mapGetters({
        isCorp: 'user/isCorp',
        CP: 'user/CP'
      }),
      ...mapState('user', {
        msgNum: state => state.msgData,
        user: state => state.user_info,
        edmMsg: state => state.edmMsg
      }),
      showHeader() {
        return this.$route.meta && !this.$route.meta.noHeader
      },
      customHead() {
        return this.$route.meta && this.$route.meta.customHead
      },
      // ...mapState({
      //   user_info: state => state.user.user_info
      // }),
      logoType() {
        return this.$store.state.user.language == 'zh-cn' ? 'l_zh_cn' : ''
      },
      // 当前路由对应的菜单
      currentMenu() {
        const { meta } = this.$route
        return meta ? meta.activeMenu : ''
      },
      // 显示升级到
      showUpgradeOfficial() {
        const purchase_product = this.user_info.purchase_product
        const flag =
          this.CP('show_manage') &&
          this.isCorp &&
          purchase_product &&
          (purchase_product['package_level'] == this.PAYMENT.PAY_PACKAGE_LEVEL_TRIAL ||
            purchase_product['package_level'] == this.PAYMENT.PAY_PACKAGE_LEVEL_FREE)
        return flag
      },
      showJPMenuItem() {
        const purchase_product = this.user_info.purchase_product
        return (
          this.$i18n.locale == 'ja-jp' &&
          this.user_info.district == 'riben' &&
          purchase_product['show_link'] == 1
        )
      },
      showAdminGuide() {
        return this.CP('show_manage') && this.$route.path == '/card/view'
      },
      wap() {
        const wapArr = ['/tool/googlecontact', '/tool/outlookcontact', '/tool/export']
        return ua.wap && wapArr.includes(this.$route.path)
      }
    },
    watch: {
      msgNum(data) {
        // 记录当前信息数
        // 1超管：名片上传（权限）、名片共享、任务协作、人事变更、待加入同事
        // 3只读用户：名片上传、名片共享
        // 0标准用户：名片上传（权限）、名片共享、任务协作、人事变更
        // 2管理员：待加入同事
        let total = 0
        if (this.user.role === 0) {
          // 标准用户
          total = data.task_num + data.share_num + data.upload_card_num + data.hrchange_num
        } else if (this.user.role === 1) {
          // 超级管理员
          total =
            data.apply_num +
            data.task_num +
            data.share_num +
            data.upload_card_num +
            data.hrchange_num
        } else if (this.user.role === 2) {
          // 管理员
          total = data.apply_num || 0
        } else if (this.user.role === 3) {
          // 只读用户
          total = data.share_num + data.upload_card_num
        }
        let pre = getCookie('_cc_message') || 0
        pre = parseInt(pre)
        this.hasNewMsg = total > pre
        if (this.$route.query.first == 1) {
          // 刚登录完跳转到名片夹页
          this.showMsgMenu = this.hasNewMsg
          this.hasNewMsg &&
            setTimeout(() => {
              this.showMsgMenu = false
            }, 5000)
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.user_info = JSON.parse(JSON.stringify(this.$store.state.user.user_info))
        this.checkFirstLogin()
      })
      this.initUrl()
      this.getMessageCount()

      this.$EventBus.$on('admin-expire', need_expire => {
        this.adminExpire = need_expire
      })
    },
    methods: {
      delayHide(flag) {
        setTimeout(() => {
          this[flag] = false
        }, 300)
      },
      handleShowMsg() {
        this.showMsgMenu = true
        this.$log.action('click_message_tab')
      },
      toGO(path, log) {
        log && this.$log.action(log)
        if (path === '/edm/list' && this.edmMsg.show_edm_point) {
          this.$store.commit('user/setEdmMsg', { ...this.edmMsg, show_edm_point: 0 })
          report_edm_click({ event: 'click_edm_point' })
        }

        this.$router.push({
          path
        })
      },
      checkFirstLogin() {
        if (!useLoginStatus()) return
        const { no_need_check_first_login } = this.$store.state.user.checkReqConfig
        !no_need_check_first_login &&
          check_first_login({}).then(res => {
            if (res.errno == 0) {
              if (res.data === 1) {
                if (this.user_info.is_creator === 1 && !ua.wap) {
                  if (this.$i18n.locale == 'zh-cn' || this.$i18n.locale == 'en-us') {
                    this.$refs.questionnaire.visible = true
                  } else {
                    this.openNewcomerGuide()
                  }
                }
              } else {
                this.$store.commit('user/setCheckReqConfig', { no_need_check_first_login: 1 })
                localStorage.resetLang = '' // 已完善公司信息
                if (!this.$store.state.user.isChZnAccount) {
                  this.getEdmMsg()
                }
              }
            }
          })
      },
      goToHelpCenter() {
        this.$router.push('/help_center_pc')
        this.$log.action('CC_HELP_GUID', { type: 'count' })
      },
      openNewcomerGuide() {
        this.$refs.newcomerGuide.visible = true
        this.$log.action('CC_GUIDE_ENTER_FLOW', { type: 'count' })
      },
      handleUserMenu(flag) {
        if (flag) this.ableTooltip = false
      },
      checkActiveMenu(name) {
        return this.currentMenu == name
      },
      handleViewProfile() {
        if (this.user_info && this.user_info.user_id) {
          let query = this.$route.query
          if (
            this.$route.path === '/colleague/view' &&
            query.colleague_id == this.user_info.user_id
          ) {
            this.$router.go(0)
          } else {
            this.$router.push({
              path: '/colleague/view',
              query: { colleague_id: this.user_info.user_id }
            })
          }
        }
      },
      // 登出
      async handleLogout() {
        this.$log.action('click_sign_out')
        this.quitLoading = true
        try {
          updateDpsPopupStatus()
          await this.$store.dispatch('user/logout')
          localStorage.removeItem('showDpsTips')
          this.$router.push({ path: '/user/login', replace: true })
        } catch (error) {}
        this.quitLoading = false
      },
      // 获取消息数据
      async getMessageCount() {
        if (!useLoginStatus()) return
        const data = await getLatestMessage({})
        if (data.errno == 0) {
          this.$store.commit('user/setMsgNum', data.data)
        }
      },
      initUrl() {
        const locale = this.$i18n.locale
        switch (locale) {
          case 'zh-cn': {
            this.helpUrl = 'https://s.intsig.net/ccbusiness/CamCard_Business_FAQ_zh-cn.pdf'
            this.userManual =
              'https://s.intsig.net/ccbusiness/CamCard_Business_User_Guide_zh-cn.pdf'
            this.adminManual =
              'https://s.intsig.net/ccbusiness/CamCard_Business_Administrator_Guide_zh-cn.pdf'
            break
          }
          case 'en-us': {
            this.helpUrl = 'https://s.intsig.net/ccbusiness/CamCard_Business_FAQ_en-us.pdf'
            this.userManual =
              'https://s.intsig.net/ccbusiness/CamCard_Business_User_Guide_en-us.pdf'
            this.adminManual =
              'https://s.intsig.net/ccbusiness/CamCard_Business_Administrator_Guide_en-us.pdf'
            break
          }
          case 'ja-jp': {
            this.helpUrl = 'https://s.intsig.net/ccbusiness/CamCard_Business_FAQ_ja-jp.pdf'
            this.userManual =
              'https://s.intsig.net/ccbusiness/CamCard_Business_User_Guide_ja-jp.pdf'
            this.adminManual =
              'https://s.intsig.net/ccbusiness/CamCard_Business_Administrator_Guide_ja-jp.pdf'
            break
          }
          case 'ko-kr': {
            this.helpUrl = 'https://s.intsig.net/ccbusiness/CamCard_Business_FAQ_ko-kr.pdf'
            this.userManual =
              'https://s.intsig.net/ccbusiness/CamCard_Business_User_Guide_ko-kr.pdf'
            this.adminManual =
              'https://s.intsig.net/ccbusiness/CamCard_Business_Administrator_Guide_ko-kr.pdf'
            break
          }
          default: {
            this.helpUrl = 'https://s.intsig.net/ccbusiness/CamCard_Business_FAQ_en-us.pdf'
            this.userManual =
              'https://s.intsig.net/ccbusiness/CamCard_Business_User_Guide_en-us.pdf'
            this.adminManual =
              'https://s.intsig.net/ccbusiness/CamCard_Business_Administrator_Guide_en-us.pdf'
          }
        }

        if (locale == 'ja-jp') {
          this.vipSupportEmail = CONFIG.CONTACTUS_JP_EMAIL
        } else if (locale == 'ko-kr') {
          this.vipSupportEmail = CONFIG.CONTACTUS_KR_EMAIL
        } else {
          this.vipSupportEmail = CONFIG.CONTACTUS_EMAIL
        }

        if (locale == 'ja-jp') {
          this.downloadUrl = 'https://www.camcard.jp/business/download/'
          this.contactUs = 'https://www.camcard.jp/business/contact/index.php'
        } else {
          this.downloadUrl = `${CONFIG.CORPORATION_MAIN_URL}/site/download`
          this.contactUs = `mailto:${this.vipSupportEmail}`
        }
        // TODO: 日文环境链接修改
      },
      // 获取邮件弹窗和红点
      async getEdmMsg() {
        if (!useLoginStatus()) return
        const data = await get_edm_pop({})
        if (data.errno == 0) {
          this.$store.commit('user/setEdmMsg', data.data)
        }
      }
    }
  }
</script>
<style lang="scss" src="./index.scss" scoped></style>
